module.exports = __webpack_public_path__ + "img/potion-large.a11cdc20.svg";